import React from 'react';
import PropTypes from 'prop-types';
import SelfClosingModal from './common/SelfClosingModal';
import AccessKeyDisplay from '../../shared/components/AccessKeyDisplay';

export default function TaskAssignedModal({ 
  show, 
  onClose, 
  taskData, 
  error = null 
}) {
  if (error) {
    return (
      <SelfClosingModal
        show={show}
        onClose={onClose}
        title="Task Assignment Failed"
        autoCloseDelay={10000} // Give more time for error messages
        size="" // Use default medium size
      >
        <div className="text-center">
          <div className="mb-3">
            <i className="bi bi-exclamation-triangle text-warning" style={{ fontSize: '3rem' }}></i>
          </div>
          <h5 className="text-danger">Failed to Create Task</h5>
          <p className="text-muted">{error}</p>
        </div>
      </SelfClosingModal>
    );
  }

  if (!taskData) {
    return null;
  }

  const { asset, workflow, task } = taskData;

  return (
    <SelfClosingModal
      show={show}
      onClose={onClose}
      title="Task Assigned"
      autoCloseDelay={5000}
      size=""
      progressVariant="green"
    >
      <div className="text-center">
        {/* Success Icon */}
        <div className="mb-3">
          <i className="bi bi-check-circle text-success" style={{ fontSize: '3rem' }}></i>
        </div>

        {/* Asset Information */}
        <div className="mb-4">
          <div className="text-muted small text-uppercase">Asset</div>
          <div className="fw-bold fs-5">{asset.asset_name || 'Unnamed Asset'}</div>
        </div>

        {/* Workflow Information */}
        <div className="mb-4">
          <div className="text-muted small text-uppercase">Workflow</div>
          <div className="fw-bold fs-5">{workflow.name}</div>
        </div>

        {/* Task Access Key */}
        <div className="mb-3">
          <div className="text-muted small text-uppercase mb-2">Task Access Key</div>
          <AccessKeyDisplay 
            accessKeyToken={task.access_key}
            accessDurationUntil={task.access_duration_until}
            variant="modal"
          />
        </div>

        {/* Additional Info */}
        <div className="text-muted small">
          <div>Assigned to: {task.assigned_to_email}</div>
          {task.ticket_reference && (
            <div>Ticket: {task.ticket_reference}</div>
          )}
        </div>
      </div>
    </SelfClosingModal>
  );
}

TaskAssignedModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  taskData: PropTypes.shape({
    asset: PropTypes.object.isRequired,
    workflow: PropTypes.object.isRequired,
    task: PropTypes.object.isRequired
  }),
  error: PropTypes.string
};
